/**
 * Generates a random string for making filenames unique
 * @param {number} length - Length of the random string
 * @returns {string} Random string
 */
const generateRandomString = (length = 8) => {
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

/**
 * Generates a unique filename by adding a random string before the file extension
 * @param {string} originalFilename - Original filename (e.g., "imagen.png")
 * @returns {string} Unique filename (e.g., "imagen_a82hdkd1.png")
 */
export const generateUniqueFilename = (originalFilename) => {
  const lastDotIndex = originalFilename.lastIndexOf(".");

  if (lastDotIndex === -1) {
    // No extension found, just append random string
    return `${originalFilename}_${generateRandomString()}`;
  }

  const nameWithoutExtension = originalFilename.substring(0, lastDotIndex);
  const extension = originalFilename.substring(lastDotIndex);

  return `${nameWithoutExtension}_${generateRandomString()}${extension}`;
};
